import React from "react";
import { Link } from "react-router-dom";

/* ------------------------------------------------------------------
   IMAGE PATHS  (files live in  src/assets/images/ )
   Put your pictures in that folder with the SAME file names below.
   If a picture is missing the page still works (navy background shows).
------------------------------------------------------------------- */
const imageFiles = require.context("../assets/images", false, /\.(png|jpe?g|webp|svg)$/);
const pic = (name) => {
  try { return imageFiles(`./${name}`); } catch (e) { return undefined; }
};
const images = {
  hero: pic("home-hero.png"),               // 1920 x 900
  intro: pic("home-intro.png"),             // 1000 x 1200
  residential: pic("home-residential.png"), // 1200 x 800
  commercial: pic("home-commercial.png"),   // 1200 x 800
  cta: pic("home-cta.png"),                 // 1920 x 700
  director: pic("about-director.png"),      // 800 x 1000 (same photo as the About page)
};
const DIRECTOR = {
  name: "Ussama Fahad",
  title: "Director, Guardian Facility Services Ltd",
};

const bg = (overlay, img) => (img ? `${overlay}, url(${img})` : overlay);

/* ------------------------------------------------------------------
   ICONS (inline SVG, no extra packages needed)
------------------------------------------------------------------- */
const paths = {
  key: (<><circle cx="7.5" cy="15.5" r="4.5" /><path d="M10.8 12.2 21 2M17 6l3 3M14 9l2.5 2.5" /></>),
  wrench: <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />,
  sparkles: (<><path d="M11 3l1.9 5.1L18 10l-5.1 1.9L11 17l-1.9-5.1L4 10l5.1-1.9z" /><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" /></>),
  building: (<><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2M10 21v-3h4v3" /></>),
  shield: (<><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" /><path d="M9 12l2 2 4-4" /></>),
  clock: (<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  users: (<><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8" /></>),
  check: <path d="M5 12.5l4.5 4.5L19 7" />,
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
  phone: <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />,
  flame: <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.4-.5-2-1-3-1.07-2.14-.22-4.05 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.15.43-2.3 1-3a2.5 2.5 0 0 0 2.5 2.5z" />,
  zap: <path d="M13 2 4 14h7l-1 8 9-12h-7z" />,
  clipboard: (<><rect x="8" y="2" width="8" height="4" rx="1" /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2M9 14l2 2 4-4" /></>),
  chat: <path d="M21 12a8 8 0 0 1-11.6 7.1L3 21l1.9-5.4A8 8 0 1 1 21 12z" />,
  quote: (<><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5M9 13h6M9 17h4" /></>),
  user: (<><circle cx="12" cy="8" r="4" /><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v1" /></>),
  quoteMark: <path d="M10 11H6a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v6c0 2.5-1.5 4-4 5M20 11h-4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v6c0 2.5-1.5 4-4 5" />,
  badge: (<><circle cx="12" cy="9" r="6" /><path d="M8.5 14 7 22l5-3 5 3-1.5-8" /></>),
};

function Icon({ name, size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  );
}

/* ------------------------------------------------------------------
   PAGE CONTENT
------------------------------------------------------------------- */
const trust = [
  { icon: "shield", title: "Vetted and insured", text: "Fully trained, background-checked engineers and cleaners." },
  { icon: "clock", title: "24/7 emergency support", text: "Rapid maintenance response when something goes wrong." },
  { icon: "users", title: "Homes and businesses", text: "Residential and commercial properties under one roof." },
];

const residential = [
  { icon: "key", title: "Property Renting", text: "End-to-end letting services, tenant sourcing and full tenancy management." },
  { icon: "wrench", title: "Home Maintenance", text: "Quick fixes, painting, plumbing and scheduled repairs." },
  { icon: "sparkles", title: "Domestic Cleaning", text: "Regular housekeeping, deep cleaning and end-of-tenancy cleans." },
];

const commercial = [
  { icon: "building", title: "Commercial Letting", text: "Office and retail space management." },
  { icon: "wrench", title: "Facilities Maintenance", text: "Scheduled upkeep, emergency repairs and building safety checks." },
  { icon: "sparkles", title: "Commercial Cleaning", text: "Office cleaning, retail janitorial services and window washing." },
];

const steps = [
  { icon: "chat", title: "Tell us what you need", text: "Send a short message about your property and the services you want." },
  { icon: "quote", title: "Get a free estimate", text: "We review the details and come back to you with a clear quote." },
  { icon: "badge", title: "We take care of it", text: "Our team handles the letting, repairs or cleaning from start to finish." },
];

const compliance = [
  { icon: "flame", title: "Gas Safety (CP12)" },
  { icon: "zap", title: "EICR electrical report" },
  { icon: "clipboard", title: "Fire Risk Assessments" },
  { icon: "shield", title: "Deposit protection (TDS)" },
];

/* ------------------------------------------------------------------
   PAGE CSS (everything for the Home page is in this file)
------------------------------------------------------------------- */
const css = `
.hm-hero{position:relative;min-height:640px;display:flex;align-items:center;background-color:var(--navy-deep);background-size:cover;background-position:center;color:#fff}
.hm-hero .container{position:relative;padding-top:90px;padding-bottom:150px}
.hm-hero-inner{max-width:680px;animation:hmRise .8s ease-out both}
@keyframes hmRise{from{opacity:0;transform:translateY(22px)}to{opacity:1;transform:none}}
.hm-hero h1{color:#fff;font-size:clamp(34px,5.2vw,58px);font-weight:800;letter-spacing:-.5px;margin-bottom:22px}
.hm-hero p{font-size:19px;color:#DCE3EA;max-width:560px;margin-bottom:34px}
.hm-hero-btns{display:flex;gap:14px;flex-wrap:wrap}

.hm-trust{position:relative;margin-top:-64px;z-index:5}
.hm-trust-card{background:#fff;border-radius:6px;box-shadow:0 18px 40px rgba(15,34,56,.16);display:grid;grid-template-columns:repeat(3,1fr);border-top:4px solid var(--gold)}
.hm-trust-item{display:flex;gap:16px;padding:30px 28px;align-items:flex-start}
.hm-trust-item + .hm-trust-item{border-left:1px solid var(--mist)}
.hm-ico{flex:0 0 auto;width:52px;height:52px;border-radius:50%;background:var(--mist);color:var(--navy);display:grid;place-items:center}
.hm-trust-item h3{font-size:18px;margin-bottom:4px}
.hm-trust-item p{margin:0;font-size:15.5px;color:var(--muted);line-height:1.5}

.hm-section{padding-top:96px;padding-bottom:96px}
.hm-section-tight{padding-top:0;padding-bottom:96px}
.hm-head{max-width:720px;margin-bottom:48px}
.hm-head h2{font-size:clamp(28px,3.6vw,40px);font-weight:800}
.hm-head p{color:var(--muted);font-size:18px;margin:0}
.hm-head.center{margin-left:auto;margin-right:auto;text-align:center}

.hm-intro{display:grid;grid-template-columns:1fr 1.1fr;gap:72px;align-items:center;padding-top:110px}
.hm-intro-img{position:relative;padding:0 0 28px 28px}
.hm-intro-img::before{content:"";position:absolute;left:0;bottom:0;width:72%;height:72%;background:var(--navy);border-radius:6px}
.hm-intro-img img{position:relative;width:100%;aspect-ratio:5/6;object-fit:cover;border-radius:6px;background:var(--mist)}
.hm-intro h2{font-size:clamp(28px,3.6vw,40px);font-weight:800}
.hm-intro p{color:var(--muted);font-size:18px}
.hm-list{list-style:none;margin:26px 0 34px;padding:0;display:grid;gap:14px}
.hm-list li{display:flex;gap:12px;align-items:flex-start;font-weight:600;color:var(--navy)}
.hm-list .tick{flex:0 0 auto;width:26px;height:26px;border-radius:50%;background:var(--navy);color:#fff;display:grid;place-items:center;margin-top:1px}

.hm-panels{display:grid;grid-template-columns:1fr 1fr;gap:32px}
.hm-panel{background:#fff;border:1px solid #E1E6EB;border-radius:6px;overflow:hidden;display:flex;flex-direction:column}
.hm-panel-img{position:relative;height:250px;background:var(--navy);overflow:hidden}
.hm-panel-img img{width:100%;height:100%;object-fit:cover}
.hm-panel-img::after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(15,34,56,0) 40%,rgba(15,34,56,.82))}
.hm-panel-img h3{position:absolute;left:28px;bottom:20px;z-index:2;color:#fff;font-size:26px;margin:0}
.hm-panel-body{padding:12px 28px 28px;display:flex;flex-direction:column;flex:1}
.hm-row{display:flex;gap:16px;padding:20px 0;border-bottom:1px solid var(--mist)}
.hm-row:last-of-type{border-bottom:0}
.hm-row h4{font-size:18px;margin-bottom:4px}
.hm-row p{margin:0;color:var(--muted);font-size:16px;line-height:1.55}
.hm-link{margin-top:auto;display:inline-flex;align-items:center;gap:8px;font-family:var(--font-head);font-weight:600;color:var(--navy);text-decoration:none;padding-top:8px}
.hm-link:hover{color:var(--gold-dark)}

.hm-dir{display:grid;grid-template-columns:300px 1fr;gap:56px;align-items:center;background:var(--paper);border:1px solid #E1E6EB;border-left:5px solid var(--gold);border-radius:6px;padding:40px 48px 40px 40px}
.hm-dir-photo{position:relative;aspect-ratio:4/5;border-radius:6px;overflow:hidden;background:var(--navy);box-shadow:0 16px 36px rgba(15,34,56,.2)}
.hm-dir-photo img{width:100%;height:100%;object-fit:cover;transition:transform 1s ease}
.hm-dir:hover .hm-dir-photo img{transform:scale(1.04)}
.hm-dir-empty{position:absolute;inset:0;display:grid;place-items:center;color:rgba(255,255,255,.35)}
.hm-dir-quote{color:var(--gold);margin-bottom:6px}
.hm-dir h2{font-size:clamp(26px,3.2vw,36px);font-weight:800;margin-bottom:16px}
.hm-dir p{color:#3A4652;font-size:18px;max-width:640px}
.hm-dir-by{display:flex;align-items:center;gap:16px;flex-wrap:wrap;margin-top:24px}
.hm-dir-by strong{display:block;font-family:var(--font-head);font-style:italic;font-size:22px;color:var(--navy);line-height:1.2}
.hm-dir-by span{display:block;color:var(--muted);font-size:15px}
.hm-dir-btn{margin-top:26px}

.hm-steps-wrap{background:var(--paper)}
.hm-steps{display:grid;grid-template-columns:repeat(3,1fr);gap:28px;position:relative}
.hm-step{background:#fff;border-radius:6px;padding:34px 28px;border:1px solid #E1E6EB}
.hm-step .hm-ico{background:var(--navy);color:#fff;margin-bottom:20px}
.hm-step h3{font-size:20px}
.hm-step p{margin:0;color:var(--muted);font-size:16px}

.hm-comp{background:var(--navy);color:#fff;padding-top:80px;padding-bottom:80px}
.hm-comp-grid{display:grid;grid-template-columns:1fr 1.2fr;gap:56px;align-items:center}
.hm-comp h2{color:#fff;font-size:clamp(26px,3.2vw,36px);font-weight:800}
.hm-comp p{color:#C4CFDA;margin:0;font-size:18px}
.hm-comp-items{display:grid;grid-template-columns:1fr 1fr;gap:16px}
.hm-comp-item{display:flex;gap:14px;align-items:center;padding:18px 20px;border:1px solid rgba(185,194,204,.3);border-radius:6px;background:rgba(255,255,255,.04);font-family:var(--font-head);font-weight:600;font-size:16px}
.hm-comp-item svg{color:var(--gold);flex:0 0 auto}

.hm-cta{position:relative;padding-top:110px;padding-bottom:110px;text-align:center;color:#fff;background-color:var(--navy-deep);background-size:cover;background-position:center}
.hm-cta h2{color:#fff;font-size:clamp(28px,4vw,44px);font-weight:800;max-width:760px;margin:0 auto 16px}
.hm-cta p{color:#DCE3EA;font-size:19px;max-width:560px;margin:0 auto 34px}
.hm-cta-btns{display:flex;gap:14px;justify-content:center;flex-wrap:wrap}
.hm-cta .btn svg{vertical-align:-5px;margin-right:8px}

@media (max-width:980px){
  .hm-trust-card{grid-template-columns:1fr}
  .hm-trust-item + .hm-trust-item{border-left:0;border-top:1px solid var(--mist)}
  .hm-intro{grid-template-columns:1fr;gap:48px;padding-top:80px}
  .hm-panels,.hm-steps,.hm-comp-grid{grid-template-columns:1fr}
  .hm-dir{grid-template-columns:1fr;gap:32px;padding:32px 24px;text-align:left}
  .hm-dir-photo{max-width:280px;width:100%}
  .hm-section{padding-top:72px;padding-bottom:72px}
  .hm-section-tight{padding-bottom:72px}
}
@media (max-width:560px){
  .hm-hero{min-height:560px}
  .hm-hero .container{padding-top:60px;padding-bottom:120px}
  .hm-comp-items{grid-template-columns:1fr}
  .hm-panel-img{height:200px}
}
`;

/* ------------------------------------------------------------------
   COMPONENT
------------------------------------------------------------------- */
function ServiceRows({ items }) {
  return items.map((s) => (
    <div className="hm-row" key={s.title}>
      <div className="hm-ico"><Icon name={s.icon} /></div>
      <div>
        <h4>{s.title}</h4>
        <p>{s.text}</p>
      </div>
    </div>
  ));
}

export default function Home() {
  return (
    <>
      <style>{css}</style>

      {/* HERO */}
      <section
        className="hm-hero"
        style={{ backgroundImage: bg("linear-gradient(90deg, rgba(15,34,56,.92) 0%, rgba(15,34,56,.72) 45%, rgba(15,34,56,.35) 100%)", images.hero) }}
      >
        <div className="container">
          <div className="hm-hero-inner">
            <h1>Complete Property Rental, Maintenance and Cleaning Across the UK.</h1>
            <p>
              Reliable property management and facility care for landlords, tenants and business
              owners. We handle everything from finding tenants to keeping your buildings pristine.
            </p>
            <div className="hm-hero-btns">
              <Link to="/services" className="btn btn-gold">Explore Our Services</Link>
              <Link to="/contact" className="btn btn-outline">Get a Free Quote</Link>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST BAR */}
      <section className="hm-trust">
        <div className="container">
          <div className="hm-trust-card">
            {trust.map((t) => (
              <div className="hm-trust-item" key={t.title}>
                <div className="hm-ico"><Icon name={t.icon} size={26} /></div>
                <div>
                  <h3>{t.title}</h3>
                  <p>{t.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* VALUE PROPOSITION */}
      <section className="hm-section hm-intro container">
        <div className="hm-intro-img">
          <img src={images.intro} alt="Guardian Facility Services property care" />
        </div>
        <div>
          <h2>Your All-in-One Property Partners</h2>
          <p>
            At Guardian Facility Services Ltd, we bridge the gap between property management and
            hands-on maintenance. Whether you are a residential landlord looking to rent out a flat,
            a homeowner needing a deep clean, or a business owner requiring scheduled commercial
            maintenance, we handle it all.
          </p>
          <p>
            By combining rental management, professional cleaning and expert maintenance under one
            roof, we save you time, stress and unnecessary costs.
          </p>
          <ul className="hm-list">
            {[
              "No separate letting agent, handyman and cleaning company to chase",
              "One team that adapts to the comfort of a home or the standards of a workplace",
              "Clear communication and transparent costs",
            ].map((t) => (
              <li key={t}>
                <span className="tick"><Icon name="check" size={16} /></span>
                {t}
              </li>
            ))}
          </ul>
          <Link to="/about" className="btn btn-navy">About Guardian Facility Services</Link>
        </div>
      </section>

      {/* WHAT WE DO */}
      <section className="hm-section hm-section-tight container">
        <div className="hm-head">
          <h2>What We Do</h2>
          <p>Property letting, maintenance and cleaning for homes and for businesses.</p>
        </div>
        <div className="hm-panels">
          <article className="hm-panel">
            <div className="hm-panel-img">
              <img src={images.residential} alt="Residential services" />
              <h3>Residential Services</h3>
            </div>
            <div className="hm-panel-body">
              <ServiceRows items={residential} />
              <Link to="/services" className="hm-link">View residential services <Icon name="arrow" size={18} /></Link>
            </div>
          </article>
          <article className="hm-panel">
            <div className="hm-panel-img">
              <img src={images.commercial} alt="Commercial services" />
              <h3>Commercial Services</h3>
            </div>
            <div className="hm-panel-body">
              <ServiceRows items={commercial} />
              <Link to="/services" className="hm-link">View commercial services <Icon name="arrow" size={18} /></Link>
            </div>
          </article>
        </div>
      </section>

      {/* DIRECTOR TEASER */}
      <section className="hm-section-tight container">
        <div className="hm-dir">
          <div className="hm-dir-photo">
            {images.director ? (
              <img src={images.director} alt={`${DIRECTOR.name}, ${DIRECTOR.title}`} />
            ) : (
              <div className="hm-dir-empty"><Icon name="user" size={96} /></div>
            )}
          </div>
          <div>
            <div className="hm-dir-quote"><Icon name="quoteMark" size={40} /></div>
            <h2>Meet Our Director</h2>
            <p>
              We started this company on a simple idea: looking after a property should never mean
              chasing several different providers. Whether you are a landlord, a tenant, a homeowner
              or a business owner, you should be able to rely on one dependable team.
            </p>
            <div className="hm-dir-by">
              <div>
                <strong>{DIRECTOR.name}</strong>
                <span>{DIRECTOR.title}</span>
              </div>
            </div>
            <Link to="/about#director" className="btn btn-navy hm-dir-btn">Read the Full Message</Link>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="hm-steps-wrap">
        <div className="hm-section container">
          <div className="hm-head center">
            <h2>Getting Started Is Simple</h2>
            <p>Three steps from your first message to a property that is looked after.</p>
          </div>
          <div className="hm-steps">
            {steps.map((s) => (
              <div className="hm-step" key={s.title}>
                <div className="hm-ico"><Icon name={s.icon} size={26} /></div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COMPLIANCE */}
      <section className="hm-comp">
        <div className="container hm-comp-grid">
          <div>
            <h2>Landlord Compliance, Arranged for You</h2>
            <p>We arrange the mandatory UK landlord certificates and protect tenancy deposits, so your property stays compliant.</p>
          </div>
          <div className="hm-comp-items">
            {compliance.map((c) => (
              <div className="hm-comp-item" key={c.title}>
                <Icon name={c.icon} size={26} />
                {c.title}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CALL TO ACTION */}
      <section
        className="hm-cta"
        style={{ backgroundImage: bg("linear-gradient(rgba(15,34,56,.86), rgba(15,34,56,.86))", images.cta) }}
      >
        <div className="container">
          <h2>Ready to take the hassle out of property care?</h2>
          <p>Let's discuss your residential or commercial property needs today.</p>
          <div className="hm-cta-btns">
            <Link to="/contact" className="btn btn-gold">Contact Our Team</Link>
            <a href="tel:07459262621" className="btn btn-outline"><Icon name="phone" size={18} />07459 262621</a>
          </div>
        </div>
      </section>
    </>
  );
}